import { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { getObjectWithSelector } from '../../../functions/objectFunctions/getObjectWithSelector';
import { updateObjectNestedProperties } from '../../../functions/objectFunctions/updateObjectNestedProperties';
import { useElements, useScene } from '../../../hooks';
import { LauncherElement } from '../../../types/launcherElement';
import { sizeUnits } from '../../../types/units';
import { CornerBoxInput } from '../inputs/CornerBoxInput';
import { UnitInput } from '../inputs/UnitInput';

export const CornerBoxInputGroup = ({
  variant,
  tab,
  pseudoclass,
}: {
  variant?: string;
  tab?: string;
  pseudoclass?: string;
}) => {
  const scene = useScene();
  const lastSelectedElementID = scene.selectedElementIDs.slice(-1)[0];
  const [selectedElement, setSelectedElement] = useElements<LauncherElement>({
    id: lastSelectedElementID,
  });
  const [point, setPoint] = useState<
    'TopLeft' | 'TopRight' | 'BottomLeft' | 'BottomRight' | 'All'
  >('All');

  let selector: string = 'props.class';
  if (variant && tab) {
    selector = `props.class.variants.${variant}.${tab}`;
  }

  if (pseudoclass === 'none') pseudoclass = undefined;
  if (pseudoclass) {
    selector = `${selector}.&:${pseudoclass}`;
  }

  let propertySelector = `borderRadius`;
  if (point !== 'All') propertySelector = `border${point}Radius`;

  const styleObj = getObjectWithSelector(selectedElement, selector);
  const id = `${lastSelectedElementID}-${variant}-borderRadius-${tab}-${pseudoclass}-input`;

  useEffect(() => {
    setPoint('All');
  }, [lastSelectedElementID]);

  return (
    <Container>
      <CornerBoxInput {...{ point, setPoint }} />
      <UnitInput
        id={id}
        label="Corner Radius"
        value={styleObj?.[propertySelector]}
        units={sizeUnits}
        defaultUnit="px"
        onChange={(inputValue) =>
          setSelectedElement((prev) =>
            updateObjectNestedProperties(prev, {
              [`${selector}.${propertySelector}`]: inputValue,
            })
          )
        }
        column
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
